import React from 'react';
import type { IconProps } from '../../types';

export const LinkedinIcon: React.FC<IconProps> = ({
  className = '',
  width = 6,
  height = 6,
  fill = 'currentColor',
  onClick,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 6 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      onClick={onClick}
    >
      <path
        d='M5.27842 0.0644531C5.42571 0.0644531 5.56696 0.122962 5.67111 0.227109C5.77526 0.331255 5.83377 0.472509 5.83377 0.619794V4.50718C5.83377 4.65447 5.77526 4.79572 5.67111 4.89987C5.56696 5.00402 5.42571 5.06252 5.27842 5.06252H1.39103C1.24375 5.06252 1.1025 5.00402 0.998349 4.89987C0.894202 4.79572 0.835693 4.65447 0.835693 4.50718V0.619794C0.835693 0.472509 0.894202 0.331255 0.998349 0.227109C1.1025 0.122962 1.24375 0.0644531 1.39103 0.0644531H5.27842ZM5.13959 4.36835V2.89669C5.13959 2.65662 5.04422 2.42638 4.87446 2.25662C4.7047 2.08686 4.47446 1.99149 4.23438 1.99149C3.99836 1.99149 3.72347 2.13588 3.59019 2.35246V2.04424H2.81549V4.36835H3.59019V2.99943C3.59019 2.78563 3.76234 2.61069 3.97615 2.61069C4.07925 2.61069 4.17813 2.65165 4.25103 2.72455C4.32393 2.79745 4.36489 2.89633 4.36489 2.99943V4.36835H5.13959ZM1.91306 1.6083C2.03678 1.6083 2.15543 1.55915 2.24291 1.47167C2.33039 1.38419 2.37954 1.26554 2.37954 1.14182C2.37954 0.883582 2.17129 0.672552 1.91306 0.672552C1.7886 0.672552 1.66924 0.721992 1.58124 0.809996C1.49323 0.898 1.44379 1.01736 1.44379 1.14182C1.44379 1.40005 1.65482 1.6083 1.91306 1.6083ZM2.29902 4.36835V2.04424H1.52987V4.36835H2.29902Z'
        fill={fill}
      />
    </svg>
  );
};
